import { useIsDevelopment as useIsDev } from 'plume-web-utils';

export const useIsDevelopment = () => {
  return {
    isDev:
      window.location.href.includes('localhost') ||
      window.location.hostname.includes('signal-dev'),
  };
};
